/**
 * Clear domain-store dropdown mirrors on tenant switch.
 * Reference store is reset separately by useReferenceSync; these mirrors are not.
 * Length-guarded fetch sites (`if (!*ForDropdown.length)`) then refetch for the new tenant.
 */
import { useRoleStore } from '@/store/role.store.js';
import { useUserStore } from '@/store/user.store.js';
import { useUnitStore } from '@/store/unit.store.js';
import { useTeamStore } from '@/store/team.store.js';
import { useProcessStore } from '@/store/process.store.js';
import { useVendorsStore } from '@/store/vendors.store.js';

/** Module-level caches that survive React remounts (must clear on tenant change). */
const moduleCacheClearers = [];

/**
 * Register a zero-arg clearer for in-module option caches (e.g. assignmentTemplateCache).
 * @param {() => void} clearer
 * @returns {() => void} unregister
 */
export function registerModuleDropdownCacheClearer(clearer) {
    if (typeof clearer !== 'function') return () => {};
    moduleCacheClearers.push(clearer);
    return () => {
        const idx = moduleCacheClearers.indexOf(clearer);
        if (idx >= 0) moduleCacheClearers.splice(idx, 1);
    };
}

export function clearDomainDropdownCaches() {
    useRoleStore.getState().setRolesForDropdown?.([]);
    useUserStore.getState().setUsersForDropdown?.([]);
    useUnitStore.getState().setUnitsForDropdown?.([]);
    useTeamStore.getState().setTeamsForDropdown?.([]);
    useProcessStore.getState().setProcessesForDropdown?.([]);
    useVendorsStore.getState().setVendorsForDropdown?.([]);

    for (const clearer of moduleCacheClearers) {
        try {
            clearer();
        } catch {
            /* ignore */
        }
    }
}
